var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-container",class:_vm.clazz},[_c('div',{staticClass:"continue",class:_vm.clazzSpan},[_c('span',[_vm._v(_vm._s(_vm.span))])]),_c('div',{staticClass:"social-buttons"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }